export default __webpack_public_path__ + "static/media/xsats-AG-Terms-and-Conditions.16c92cbb.pdf";